import { useChecklistContext } from '../../../../contexts';
import { ChecklistSection } from '../../ChecklistPage';
import { PaddedGenericSection } from '../GenericSection';

export const OSRefName = 'os1-os3';

export default function LandRegistrySection() {
  const { checklist } = useChecklistContext();

  const {
    landRegistry,
  } = checklist ?? {};

  return (
    <PaddedGenericSection
      refName={OSRefName}
      section={ChecklistSection.OS1_OS3}
      checklistItem={landRegistry}
    >
      <p>level 0</p>
    </PaddedGenericSection>
  );
}
